const K = { session: "fs_session", answers: "fs_answers", index: "fs_index", result: "fs_result", selection: "fs_selection", extras: "fs_extras", started: "fs_started", pushed: "fs_pushed" };

const read = (k, d) => {
  try { return JSON.parse(localStorage.getItem(k)) ?? d; } catch { return d; }
};
const write = (k, v) => localStorage.setItem(k, JSON.stringify(v));

export const getSessionId = () => {
  let id = read(K.session, null);
  if (!id) { id = crypto.randomUUID ? crypto.randomUUID() : String(Date.now()); write(K.session, id); }
  return id;
};

export const flow = {
  answers: () => read(K.answers, {}),
  setAnswers: (a) => write(K.answers, a),
  index: () => read(K.index, 0),
  setIndex: (i) => write(K.index, i),
  result: () => read(K.result, null),
  setResult: (r) => write(K.result, r),
  selection: () => read(K.selection, { day: {}, night: {} }),
  setSelection: (s) => write(K.selection, s),
  extras: () => read(K.extras, []),
  setExtras: (e) => write(K.extras, e),
  started: () => read(K.started, false),
  setStarted: () => write(K.started, true),
  pushed: () => read(K.pushed, []),  // varianti già inviate al carrello Shopify (sopravvive al restart: vanno azzerate se tolte)
  setPushed: (v) => write(K.pushed, v),
  restart: () => {
    [K.answers, K.index, K.result, K.selection, K.extras, K.started].forEach((k) => localStorage.removeItem(k));
    localStorage.removeItem(K.session);
  },
};
